export function isUnknownMouseClick(e: Pick<MouseEvent, 'type' | 'button'>) {
  return e.type === 'auxclick' && e.button !== 1;
}
